import React, { Component } from 'react'
import injectSheet from 'react-jss'
import Color from 'color'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { flexUtils, palette } from '../../../Theme/Theme'
import * as Actions from '../../../Actions/Actions'
// import ReactGA from 'react-ga'

class EditName extends Component {
  componentWillMount() {
      this.setState({
          firstName: '',
          lastName: '',
          invalid: false
      })
  }

  render() {
    const { classes } = this.props
    const { Body, ActionContainer, CancelButton, SubmitButton } = classes
    return (
        <div className={Body}>
            {this.state.invalid ? <p style={{color: palette.orange}}>Both first and last name are required</p> : null}
            <input type='text' name='firstName' value={this.state.firstName} placeholder='First Name' onChange={this.onChange}/>
            <input type='text' name='lastName' value={this.state.lastName} placeholder='Last Name' onChange={this.onChange}/>
            <div className={ActionContainer}>
                <button className={CancelButton} onClick={this.onCancel}>Cancel</button>
                <button className={SubmitButton} onClick={this.onSubmit}>Submit</button>
            </div>
        </div>
    )
  }

  componentDidMount () {
    // ReactGA.pageview('/Home/EditName');
  }  

  onChange = e => {
      const name = e.target.name
      const value = e.target.value
      this.setState({
          [name]: value
      })
  }

  onCancel = () => {
      this.props.history.push('/Home/AccountInfo')
  }

  onSubmit = () => {
      const { history, dispatch, user } = this.props
      const { firstName, lastName } = this.state
      if (firstName === '' || lastName === '') {
          this.setState({ invalid: true })
      } else {
          const data = {
              firstName: firstName,
              lastName: lastName
          }
          dispatch(Actions.updateUser(user.token, data, history))
      }
  }
}

const styles = {
    ...flexUtils,
    Body: {
        composes: ['$FlexColumn', '$FlexCenter'],
        width: '80%',
        height: '95.5vh',
        '& input': {
            fontSize: '1.5rem',
            background: 'rgba(0, 0, 0, 0)',
            border: 'none',
            borderBottom: '1px solid rgb(160, 160, 160)',
            width: '100%',
            maxWidth: '30rem',
            margin: '2rem 0rem',
            color: palette.lightFont,
            transition: 'all .5s',
            '&:focus': {
                outline: 'none',
                borderBottom: `1px solid ${palette.blue}`,
                '&::placeholder': {
                    color: palette.blue
                }
            },
            '&::placeholder': {
                color: 'rgb(160, 160, 160)',
                transition: 'all .5s'
            }
        }
    },
    ActionContainer: {
        composes: ['$FlexRow'],
        justifyContent: 'flex-end',
        width: '100%',
        maxWidth: '30rem',
    },
    Button: {
        margin: '1rem 0rem 0rem 1rem',
        height: '2.2rem',
        width: '7rem',
        border: 'none',
        borderRadius: '3px',
        fontSize: '1.1rem',
        transition: 'all .2s',
        '&:hover': {
            cursor: 'pointer'
        },
        '&:focus': {
            outline: 'none'
        }
    },
    CancelButton: {
        composes: '$Button',
        '&:hover': {
            background: 'rgb(190, 190, 190)'
        }
    },
    SubmitButton: {
        composes: '$Button',
        background: palette.blue,
        color: palette.lightFont,
        '&:hover': {
            background: `${Color(palette.blue).darken(0.2)}`
        }
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.mainState.user
    }
}

export default withRouter(connect(mapStateToProps)(injectSheet(styles)(EditName)))



// WEBPACK FOOTER //
// ./src/js/Components/Home/Settings/EditName.jsx